import { render } from "./mainContent.vue?vue&type=template&id=37e26e8e&scoped=true"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-37e26e8e"

export default script